import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class EntitySchemaService {
  private readonly http = inject(HttpClient);

  /**
   * EntitySchema JSON（ファイルシステム上の定義）を index-core から取得する。
   * - 大きい場合もあるので、まずはテキストで取得してUIにそのまま表示する。
   */
  getEntitySchemaText(schemaPath: string): Observable<string> {
    const params = new HttpParams()
      .set('bucketCode', environment.bucketCodeMapping)
      .set('fileSystemId', schemaPath);
    return this.http.get(environment.fileSystemApiUrl, { params, responseType: 'text' });
  }
}

